export default function StatusBadge({
  status,
  color,
  className,
  onClick,
}: {
  status: string | null;
  color?: string;
  className?: string;
  onClick?: () => void;
}) {
  function determineStatusColor(status: string | null) {
    if (className) {
      return className;
    }
    if (color) {
      return `bg-${color}-200 text-${color}-800`;
    }
    switch (status) {
      case "DONE":
        return "bg-green-200 text-green-800";
      case "PEN":
        return "bg-blue-200 text-blue-800";
      case "WIP":
        return "bg-orange-200 text-orange-800";
      case "DENIED":
        return "bg-red-200 text-red-800";
      default:
        return "bg-slate-300 text-slate-800";
    }
  }

  return (
    <div
      onClick={onClick}
      className={`flex justify-center rounded px-2.5 py-0.5 text-sm font-semibold h-6 ${determineStatusColor(
        status
      )}`}
    >
      <div>{status ? status.toUpperCase() : ""}</div>
    </div>
  );
}
